export const MASKS = {
  AF: { mask: '+93 ## ### ####', placeholder: '+93 00 000 0000' },
  AL: { mask: '+355 ## ### ####', placeholder: '+355 00 000 0000' },
  DZ: { mask: '+213 ### ## ## ##', placeholder: '+213 000 00 00 00' },
  AS: { mask: '+1684 ### ####', placeholder: '+1684 000 0000' },
  AD: { mask: '+376 ### ###', placeholder: '+376 000 000' },
  AO: { mask: '+244 ### ### ###', placeholder: '+244 000 000 000' },
  AI: { mask: '+1264 ### ####', placeholder: '+1264 000 0000' },
  AG: { mask: '+1268 ### ####', placeholder: '+1268 000 0000' },
  AR: { mask: '+54 # ## #### ####', placeholder: '+54 0 00 0000 0000' },
  AM: { mask: '+374 ## ######', placeholder: '+374 00 000000' },
  AW: { mask: '+297 ### ####', placeholder: '+297 000 0000' },
  AU: { mask: '+61 ### ### ###', placeholder: '+61 000 000 000' },
  AT: { mask: '+43 ### ######', placeholder: '+43 000 000000' },
  AZ: { mask: '+994 ## ### ## ##', placeholder: '+994 00 000 00 00' },
  BS: { mask: '+1242 ### ####', placeholder: '+1242 000 0000' },
  BH: { mask: '+973 #### ####', placeholder: '+973 0000 0000' },
  BD: { mask: '+880 #### ######', placeholder: '+880 0000 000000' },
  BB: { mask: '+1246 ### ####', placeholder: '+1246 000 0000' },
  BY: { mask: '+375 ## ### ## ##', placeholder: '+375 00 000 00 00' },
  BE: { mask: '+32 ### ## ## ##', placeholder: '+32 000 00 00 00' },
  BZ: { mask: '+501 ### ####', placeholder: '+501 000 0000' },
  BJ: { mask: '+229 ## ## ## ##', placeholder: '+229 00 00 00 00' },
  BM: { mask: '+1441 ### ####', placeholder: '+1441 000 0000' },
  BT: { mask: '+975 ## ## ## ##', placeholder: '+975 00 00 00 00' },
  BO: { mask: '+591 ########', placeholder: '+591 00000000' },
  BA: { mask: '+387 ## ### ###', placeholder: '+387 00 000 000' },
  BW: { mask: '+267 ## ### ###', placeholder: '+267 00 000 000' },
  BR: { mask: '+55 ## ##### ####', placeholder: '+55 00 00000 0000' },
  IO: { mask: '+246 ### ####', placeholder: '+246 000 0000' },
  VG: { mask: '+1284 ### ####', placeholder: '+1284 000 0000' },
  BN: { mask: '+673 ### ####', placeholder: '+673 000 0000' },
  BG: { mask: '+359 ## ### ###', placeholder: '+359 00 000 000' },
  BF: { mask: '+226 ## ## ## ##', placeholder: '+226 00 00 00 00' },
  BI: { mask: '+257 ## ## ## ##', placeholder: '+257 00 00 00 00' },
  KH: { mask: '+855 ## ### ###', placeholder: '+855 00 000 000' },
  CM: { mask: '+237 # ## ## ## ##', placeholder: '+237 0 00 00 00 00' },
  CA: { mask: '+1 ### ### ####', placeholder: '+1 000 000 0000' },
  CV: { mask: '+238 ### ## ##', placeholder: '+238 000 00 00' },
  BQ: { mask: '+599 ### ####', placeholder: '+599 000 0000' },
  KY: { mask: '+1345 ### ####', placeholder: '+1345 000 0000' },
  CF: { mask: '+236 ## ## ## ##', placeholder: '+236 00 00 00 00' },
  TD: { mask: '+235 ## ## ## ##', placeholder: '+235 00 00 00 00' },
  CL: { mask: '+56 # #### ####', placeholder: '+56 0 0000 0000' },
  CN: { mask: '+86 ### #### ####', placeholder: '+86 000 0000 0000' },
  CX: { mask: '+61 ### ### ###', placeholder: '+61 000 000 000' },
  CC: { mask: '+61 ### ### ###', placeholder: '+61 000 000 000' },
  CO: { mask: '+57 ### #######', placeholder: '+57 000 0000000' },
  KM: { mask: '+269 ### ## ##', placeholder: '+269 000 00 00' },
  CD: { mask: '+243 ### ### ###', placeholder: '+243 000 000 000' },
  CG: { mask: '+242 ## ### ####', placeholder: '+242 00 000 0000' },
  CK: { mask: '+682 ## ###', placeholder: '+682 00 000' },
  CR: { mask: '+506 #### ####', placeholder: '+506 0000 0000' },
  CI: { mask: '+225 ## ## ## ####', placeholder: '+225 00 00 00 0000' },
  HR: { mask: '+385 ## ### ####', placeholder: '+385 00 000 0000' },
  CU: { mask: '+53 # #######', placeholder: '+53 0 0000000' },
  CW: { mask: '+599 # ### ####', placeholder: '+599 0 000 0000' },
  CY: { mask: '+357 ## ######', placeholder: '+357 00 000000' },
  CZ: { mask: '+420 ### ### ###', placeholder: '+420 000 000 000' },
  DK: { mask: '+45 ## ## ## ##', placeholder: '+45 00 00 00 00' },
  DJ: { mask: '+253 ## ## ## ##', placeholder: '+253 00 00 00 00' },
  DM: { mask: '+1767 ### ####', placeholder: '+1767 000 0000' },
  DO: { mask: '+1 ### ### ####', placeholder: '+1 000 000 0000' },
  EC: { mask: '+593 ## ### ####', placeholder: '+593 00 000 0000' },
  EG: { mask: '+20 ### ### ####', placeholder: '+20 000 000 0000' },
  SV: { mask: '+503 #### ####', placeholder: '+503 0000 0000' },
  GQ: { mask: '+240 ### ### ###', placeholder: '+240 000 000 000' },
  ER: { mask: '+291 # ### ###', placeholder: '+291 0 000 000' },
  EE: { mask: '+372 #### ####', placeholder: '+372 0000 0000' },
  ET: { mask: '+251 ## ### ####', placeholder: '+251 00 000 0000' },
  FK: { mask: '+500 #####', placeholder: '+500 00000' },
  FO: { mask: '+298 ######', placeholder: '+298 000000' },
  FJ: { mask: '+679 ### ####', placeholder: '+679 000 0000' },
  FI: { mask: '+358 ## #######', placeholder: '+358 00 0000000' },
  FR: { mask: '+33 # ## ## ## ##', placeholder: '+33 0 00 00 00 00' },
  GF: { mask: '+594 ### ## ## ##', placeholder: '+594 000 00 00 00' },
  PF: { mask: '+689 ## ## ## ##', placeholder: '+689 00 00 00 00' },
  GA: { mask: '+241 ## ## ## ##', placeholder: '+241 00 00 00 00' },
  GM: { mask: '+220 ### ####', placeholder: '+220 000 0000' },
  GE: { mask: '+995 ### ## ## ##', placeholder: '+995 000 00 00 00' },
  DE: { mask: '+49 #### #######', placeholder: '+49 0000 0000000' },
  GH: { mask: '+233 ## ### ####', placeholder: '+233 00 000 0000' },
  GI: { mask: '+350 ########', placeholder: '+350 00000000' },
  GR: { mask: '+30 ### ### ####', placeholder: '+30 000 000 0000' },
  GL: { mask: '+299 ## ## ##', placeholder: '+299 00 00 00' },
  GD: { mask: '+1473 ### ####', placeholder: '+1473 000 0000' },
  GP: { mask: '+590 ### ## ## ##', placeholder: '+590 000 00 00 00' },
  GU: { mask: '+1671 ### ####', placeholder: '+1671 000 0000' },
  GT: { mask: '+502 #### ####', placeholder: '+502 0000 0000' },
  GG: { mask: '+44 #### ######', placeholder: '+44 0000 000000' },
  GN: { mask: '+224 ### ## ## ##', placeholder: '+224 000 00 00 00' },
  GW: { mask: '+245 ### ### ###', placeholder: '+245 000 000 000' },
  GY: { mask: '+592 ### ####', placeholder: '+592 000 0000' },
  HT: { mask: '+509 ## ## ####', placeholder: '+509 00 00 0000' },
  HN: { mask: '+504 #### ####', placeholder: '+504 0000 0000' },
  HK: { mask: '+852 #### ####', placeholder: '+852 0000 0000' },
  HU: { mask: '+36 ## ### ####', placeholder: '+36 00 000 0000' },
  IS: { mask: '+354 ### ####', placeholder: '+354 000 0000' },
  IN: { mask: '+91 ##### #####', placeholder: '+91 00000 00000' },
  ID: { mask: '+62 ### ### ###', placeholder: '+62 000 000 000' },
  IR: { mask: '+98 ### ### ####', placeholder: '+98 000 000 0000' },
  IQ: { mask: '+964 ### ### ####', placeholder: '+964 000 000 0000' },
  IE: { mask: '+353 ## ### ####', placeholder: '+353 00 000 0000' },
  IM: { mask: '+44 #### ######', placeholder: '+44 0000 000000' },
  IL: { mask: '+972 ## ### ####', placeholder: '+972 00 000 0000' },
  IT: { mask: '+39 ### ### ####', placeholder: '+39 000 000 0000' },
  JM: { mask: '+1876 ### ####', placeholder: '+1876 000 0000' },
  JP: { mask: '+81 ## #### ####', placeholder: '+81 00 0000 0000' },
  JE: { mask: '+44 #### ######', placeholder: '+44 0000 000000' },
  JO: { mask: '+962 # #### ####', placeholder: '+962 0 0000 0000' },
  KZ: { mask: '+7 ### ### ####', placeholder: '+7 000 000 0000' },
  KE: { mask: '+254 ### ######', placeholder: '+254 000 000000' },
  KI: { mask: '+686 ########', placeholder: '+686 00000000' },
  XK: { mask: '+383 ## ### ###', placeholder: '+383 00 000 000' },
  KW: { mask: '+965 ### #####', placeholder: '+965 000 00000' },
  KG: { mask: '+996 ### ### ###', placeholder: '+996 000 000 000' },
  LA: { mask: '+856 ## ## ### ###', placeholder: '+856 00 00 000 000' },
  LV: { mask: '+371 ## ### ###', placeholder: '+371 00 000 000' },
  LB: { mask: '+961 ## ### ###', placeholder: '+961 00 000 000' },
  LS: { mask: '+266 #### ####', placeholder: '+266 0000 0000' },
  LR: { mask: '+231 ## ### ####', placeholder: '+231 00 000 0000' },
  LY: { mask: '+218 ## #######', placeholder: '+218 00 0000000' },
  LI: { mask: '+423 ### ### ###', placeholder: '+423 000 000 000' },
  LT: { mask: '+370 ### #####', placeholder: '+370 000 00000' },
  LU: { mask: '+352 ### ### ###', placeholder: '+352 000 000 000' },
  MO: { mask: '+853 #### ####', placeholder: '+853 0000 0000' },
  MK: { mask: '+389 ## ### ###', placeholder: '+389 00 000 000' },
  MG: { mask: '+261 ## ## ### ##', placeholder: '+261 00 00 000 00' },
  MW: { mask: '+265 ### ## ## ##', placeholder: '+265 000 00 00 00' },
  MY: { mask: '+60 ## ### ####', placeholder: '+60 00 000 0000' },
  MV: { mask: '+960 ### ####', placeholder: '+960 000 0000' },
  ML: { mask: '+223 ## ## ## ##', placeholder: '+223 00 00 00 00' },
  MT: { mask: '+356 #### ####', placeholder: '+356 0000 0000' },
  MH: { mask: '+692 ### ####', placeholder: '+692 000 0000' },
  MQ: { mask: '+596 ### ## ## ##', placeholder: '+596 000 00 00 00' },
  MR: { mask: '+222 ## ## ## ##', placeholder: '+222 00 00 00 00' },
  MU: { mask: '+230 #### ####', placeholder: '+230 0000 0000' },
  YT: { mask: '+262 ### ## ## ##', placeholder: '+262 000 00 00 00' },
  MX: { mask: '+52 ### ### ####', placeholder: '+52 000 000 0000' },
  FM: { mask: '+691 ### ####', placeholder: '+691 000 0000' },
  MD: { mask: '+373 ### ## ###', placeholder: '+373 000 00 000' },
  MC: { mask: '+377 # ## ## ## ##', placeholder: '+377 0 00 00 00 00' },
  MN: { mask: '+976 #### ####', placeholder: '+976 0000 0000' },
  ME: { mask: '+382 ## ### ###', placeholder: '+382 00 000 000' },
  MS: { mask: '+1664 ### ####', placeholder: '+1664 000 0000' },
  MA: { mask: '+212 ### ######', placeholder: '+212 000 000000' },
  MZ: { mask: '+258 ## ### ####', placeholder: '+258 00 000 0000' },
  MM: { mask: '+95 # ### ####', placeholder: '+95 0 000 0000' },
  NA: { mask: '+264 ## ### ####', placeholder: '+264 00 000 0000' },
  NR: { mask: '+674 ### ####', placeholder: '+674 000 0000' },
  NP: { mask: '+977 ### #######', placeholder: '+977 000 0000000' },
  NL: { mask: '+31 # ########', placeholder: '+31 0 00000000' },
  NC: { mask: '+687 ## ## ##', placeholder: '+687 00 00 00' },
  NZ: { mask: '+64 ## ### ####', placeholder: '+64 00 000 0000' },
  NI: { mask: '+505 #### ####', placeholder: '+505 0000 0000' },
  NE: { mask: '+227 ## ## ## ##', placeholder: '+227 00 00 00 00' },
  NG: { mask: '+234 ### ### ####', placeholder: '+234 000 000 0000' },
  NU: { mask: '+683 ### ####', placeholder: '+683 000 0000' },
  NF: { mask: '+672 # #####', placeholder: '+672 0 00000' },
  KP: { mask: '+850 ### ### ####', placeholder: '+850 000 000 0000' },
  MP: { mask: '+1670 ### ####', placeholder: '+1670 000 0000' },
  NO: { mask: '+47 ### ## ###', placeholder: '+47 000 00 000' },
  OM: { mask: '+968 #### ####', placeholder: '+968 0000 0000' },
  PK: { mask: '+92 ### #######', placeholder: '+92 000 0000000' },
  PW: { mask: '+680 ### ####', placeholder: '+680 000 0000' },
  PS: { mask: '+970 ### ### ###', placeholder: '+970 000 000 000' },
  PA: { mask: '+507 #### ####', placeholder: '+507 0000 0000' },
  PG: { mask: '+675 #### ####', placeholder: '+675 0000 0000' },
  PY: { mask: '+595 ### ######', placeholder: '+595 000 000000' },
  PE: { mask: '+51 ### ### ###', placeholder: '+51 000 000 000' },
  PH: { mask: '+63 ### ### ####', placeholder: '+63 000 000 0000' },
  PL: { mask: '+48 ### ### ###', placeholder: '+48 000 000 000' },
  PT: { mask: '+351 ### ### ###', placeholder: '+351 000 000 000' },
  PR: { mask: '+1 ### ### ####', placeholder: '+1 000 000 0000' },
  QA: { mask: '+974 #### ####', placeholder: '+974 0000 0000' },
  RE: { mask: '+262 ### ## ## ##', placeholder: '+262 000 00 00 00' },
  RO: { mask: '+40 ### ### ###', placeholder: '+40 000 000 000' },
  RU: { mask: '+7 ### ### ## ##', placeholder: '+7 000 000 00 00' },
  RW: { mask: '+250 ### ### ###', placeholder: '+250 000 000 000' },
  BL: { mask: '+590 ### ## ## ##', placeholder: '+590 000 00 00 00' },
  SH: { mask: '+290 #####', placeholder: '+290 00000' },
  KN: { mask: '+1869 ### ####', placeholder: '+1869 000 0000' },
  LC: { mask: '+1758 ### ####', placeholder: '+1758 000 0000' },
  MF: { mask: '+590 ### ## ## ##', placeholder: '+590 000 00 00 00' },
  PM: { mask: '+508 ## ## ##', placeholder: '+508 00 00 00' },
  VC: { mask: '+1784 ### ####', placeholder: '+1784 000 0000' },
  WS: { mask: '+685 ## #####', placeholder: '+685 00 00000' },
  SM: { mask: '+378 ## ## ## ##', placeholder: '+378 00 00 00 00' },
  ST: { mask: '+239 ### ####', placeholder: '+239 000 0000' },
  SA: { mask: '+966 ## ### ####', placeholder: '+966 00 000 0000' },
  SN: { mask: '+221 ## ### ## ##', placeholder: '+221 00 000 00 00' },
  RS: { mask: '+381 ## #######', placeholder: '+381 00 0000000' },
  SC: { mask: '+248 # ### ###', placeholder: '+248 0 000 000' },
  SL: { mask: '+232 ## ######', placeholder: '+232 00 000000' },
  SG: { mask: '+65 #### ####', placeholder: '+65 0000 0000' },
  SX: { mask: '+1721 ### ####', placeholder: '+1721 000 0000' },
  SK: { mask: '+421 ### ### ###', placeholder: '+421 000 000 000' },
  SI: { mask: '+386 ## ### ###', placeholder: '+386 00 000 000' },
  SB: { mask: '+677 ## #####', placeholder: '+677 00 00000' },
  SO: { mask: '+252 # #######', placeholder: '+252 0 0000000' },
  ZA: { mask: '+27 ## ### ####', placeholder: '+27 00 000 0000' },
  KR: { mask: '+82 ## #### ####', placeholder: '+82 00 0000 0000' },
  SS: { mask: '+211 ### ### ###', placeholder: '+211 000 000 000' },
  ES: { mask: '+34 ### ## ## ##', placeholder: '+34 000 00 00 00' },
  LK: { mask: '+94 ## ### ####', placeholder: '+94 00 000 0000' },
  SD: { mask: '+249 ## ### ####', placeholder: '+249 00 000 0000' },
  SR: { mask: '+597 ### ####', placeholder: '+597 000 0000' },
  SJ: { mask: '+47 ### ## ###', placeholder: '+47 000 00 000' },
  SZ: { mask: '+268 #### ####', placeholder: '+268 0000 0000' },
  SE: { mask: '+46 ## ### ## ##', placeholder: '+46 00 000 00 00' },
  CH: { mask: '+41 ## ### ## ##', placeholder: '+41 00 000 00 00' },
  SY: { mask: '+963 ### ### ###', placeholder: '+963 000 000 000' },
  TW: { mask: '+886 ### ### ###', placeholder: '+886 000 000 000' },
  TJ: { mask: '+992 ### ## ####', placeholder: '+992 000 00 0000' },
  TZ: { mask: '+255 ### ### ###', placeholder: '+255 000 000 000' },
  TH: { mask: '+66 ## ### ####', placeholder: '+66 00 000 0000' },
  TL: { mask: '+670 #### ####', placeholder: '+670 0000 0000' },
  TG: { mask: '+228 ## ## ## ##', placeholder: '+228 00 00 00 00' },
  TK: { mask: '+690 ####', placeholder: '+690 0000' },
  TO: { mask: '+676 ### ####', placeholder: '+676 000 0000' },
  TT: { mask: '+1868 ### ####', placeholder: '+1868 000 0000' },
  TN: { mask: '+216 ## ### ###', placeholder: '+216 00 000 000' },
  TR: { mask: '+90 ### ### ## ##', placeholder: '+90 000 000 00 00' },
  TM: { mask: '+993 ## ######', placeholder: '+993 00 000000' },
  TC: { mask: '+1649 ### ####', placeholder: '+1649 000 0000' },
  TV: { mask: '+688 ## ####', placeholder: '+688 00 0000' },
  VI: { mask: '+1340 ### ####', placeholder: '+1340 000 0000' },
  UG: { mask: '+256 ### ######', placeholder: '+256 000 000000' },
  UA: { mask: '+380 ## ### ####', placeholder: '+380 00 000 0000' },
  AE: { mask: '+971 ## ### ####', placeholder: '+971 00 000 0000' },
  GB: { mask: '+44 #### ######', placeholder: '+44 0000 000000' },
  US: { mask: '+1 ### ### ####', placeholder: '+1 000 000 0000' },
  UY: { mask: '+598 ## ### ###', placeholder: '+598 00 000 000' },
  UZ: { mask: '+998 ## ### ## ##', placeholder: '+998 00 000 00 00' },
  VU: { mask: '+678 ### ####', placeholder: '+678 000 0000' },
  VA: { mask: '+39 ### ### ####', placeholder: '+39 000 000 0000' },
  VE: { mask: '+58 ### #######', placeholder: '+58 000 0000000' },
  VN: { mask: '+84 ## ### ## ##', placeholder: '+84 00 000 00 00' },
  WF: { mask: '+681 ## ## ##', placeholder: '+681 00 00 00' },
  EH: { mask: '+212 ### ######', placeholder: '+212 000 000000' },
  YE: { mask: '+967 ### ### ###', placeholder: '+967 000 000 000' },
  ZM: { mask: '+260 ## #######', placeholder: '+260 00 0000000' },
  ZW: { mask: '+263 ## ### ####', placeholder: '+263 00 000 0000' },
  AX: { mask: '+358 ## #######', placeholder: '+358 00 0000000' },
}
